import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { PrintableFormatContainerModel, PrintableFormatExtContainerModel } from '../../../../../models/aggregates/print';
import { Core2Config } from '../shared/core2Config';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../shared/api-response.model';
import { ApiVisa } from '../shared/api-visa.model';
import { PrintableFormatCriteriaModelQuery, PrintableFormatQueryCriteriaClass } from '../../criteria';
import { Observable } from 'rxjs';
import { Pagination } from '../shared/pagination.model';

@Injectable({
  providedIn: 'root'
})
export class PrintableFormatService extends BaseApiTemplateService<PrintableFormatContainerModel> {

  readonly subUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PRINT_PREFIX + 'printable-formats';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + this.subUrl;
    this.endpoint_path = this.subUrl;
    this.httpClient = http;
  }

  getByCriteriaObservable(visa: ApiVisa, criteria?: PrintableFormatQueryCriteriaClass): Observable<ApiResponseModel<PrintableFormatContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildCriteria = new PrintableFormatCriteriaModelQuery(criteria);
    return this.httpClient.get<ApiResponseModel<PrintableFormatContainerModel>>(
      this.apiUrl + "/query?" + buildCriteria.query,
      this.getHttpHeader(visa)
    );
  }

  // ----------------------------  files related endpoints -----------------------------------------
  replaceFile(formData: FormData, extGuid: string, visa: ApiVisa) {
    let url = this.apiUrl + '/replace-file/' + extGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/replace-file/' + extGuid;
    }
    return this.httpClient.put<BasicApiResponseModel<PrintableFormatExtContainerModel>>(url, formData, this.getHttpHeader(visa));
  }

  getFile(extGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + '/file/' + extGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/' + extGuid;
    }

    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  saveToLocalDirectory(extGuid: string, dtoObject: any, visa: ApiVisa) {
    let url = this.apiUrl + '/save-file-local-directory/' + extGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/save-file-local-directory/' + extGuid;
    }
    return this.httpClient.post<BasicApiResponseModel<PrintableFormatExtContainerModel>>(url, dtoObject, this.getHttpHeader(visa));
  }

  getAllPrintableForAppletLoginEp(
    appletGuid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<PrintableFormatContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<PrintableFormatContainerModel>>(
      this.apiUrl + '/basic-info/applet-login-ep/' + appletGuid,
      this.getHttpHeader(visa)
    );
  }

  public getPrintableByCriteriaForAppletLoginEp(
    appletGuid: string,
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<PrintableFormatContainerModel>> {
    // console.log('get by criteria bsae-api');
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/basic-info/applet-login-ep/' + appletGuid + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<PrintableFormatContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getPrintableByGuidForAppletLoginEp(
    appletGuid: string,
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<PrintableFormatContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<PrintableFormatContainerModel>>(
      this.apiUrl + '/basic-info/applet-login-ep/' + appletGuid + '/' + guid,
      this.getHttpHeader(visa)
    );
  }
}
